import { jsx as m, jsxs as se } from "react/jsx-runtime";
import * as l from "react";
import { c as j } from "./index-rKs9bXHr.js";
import { u as ae, c as E } from "./index-D7uzFyzw.js";
import { c as ce, P as T, u as C } from "./index-Bud8rdvZ.js";
import { c as le, u as de } from "./index-BsL1G1kw.js";
import { u as ue } from "./index-BZPx6jYI.js";
import { u as fe } from "./index-5jQiYUd6.js";
import { O as me } from "./main-GrzMmsgg.js";
var X = ["PageUp", "PageDown"], G = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], W = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, M = "Slider", [H, Se, pe] = le(M), [q, Oe] = ce(M, [
  pe
]), [he, B] = q(M), ge = l.forwardRef(
  (e, t) => {
    const {
      name: o,
      min: n = 0,
      max: r = 100,
      step: c = 1,
      orientation: i = "horizontal",
      disabled: a = !1,
      minStepsBetweenThumbs: u = 0,
      defaultValue: b = [n],
      value: h,
      onValueChange: s = () => {
      },
      onValueCommit: d = () => {
      },
      inverted: v = !1,
      form: P,
      ...g
    } = e, S = l.useRef(/* @__PURE__ */ new Set()), f = l.useRef(0), w = i === "horizontal" ? ve : be, [p = [], K] = ae({
      prop: h,
      defaultProp: b,
      onChange: (y) => {
        [...S.current][f.current]?.focus(), s(y);
      }
    }), V = l.useRef(p);
    function N(y) {
      const x = _e(p, y);
      I(y, x);
    }
    function re(y) {
      I(y, f.current);
    }
    function ie() {
      const y = V.current[f.current];
      p[f.current] !== y && d(p);
    }
    function I(y, x, { commit: k } = { commit: !1 }) {
      const U = Ke(c), z = Ie(Math.round((y - n) / c) * c + n, U), A = j(z, [n, r]);
      K((_ = []) => {
        const R = Re(_, A, x);
        if (Me(R, u * c)) {
          f.current = R.indexOf(A);
          const Y = String(R) !== String(_);
          return Y && k && d(R), Y ? R : _;
        } else
          return _;
      });
    }
    return /* @__PURE__ */ m(
      he,
      {
        scope: e.__scopeSlider,
        name: o,
        disabled: a,
        min: n,
        max: r,
        valueIndexToChangeRef: f,
        thumbs: S.current,
        values: p,
        orientation: i,
        form: P,
        children: /* @__PURE__ */ m(H.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(H.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(
          w,
          {
            "aria-disabled": a,
            "data-disabled": a ? "" : void 0,
            ...g,
            ref: t,
            onPointerDown: E(g.onPointerDown, () => {
              a || (V.current = p);
            }),
            min: n,
            max: r,
            inverted: v,
            onSlideStart: a ? void 0 : N,
            onSlideMove: a ? void 0 : re,
            onSlideEnd: a ? void 0 : ie,
            onHomeKeyDown: () => !a && I(n, 0, { commit: !0 }),
            onEndKeyDown: () => !a && I(r, p.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: y, direction: x }) => {
              if (!a) {
                const z = X.includes(y.key) || y.shiftKey && G.includes(y.key) ? 10 : 1, A = f.current, _ = p[A], R = c * z * x;
                I(_ + R, A, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
ge.displayName = M;
var [J, Q] = q(M, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), ve = l.forwardRef(
  (e, t) => {
    const {
      min: o,
      max: n,
      dir: r,
      inverted: c,
      onSlideStart: i,
      onSlideMove: a,
      onSlideEnd: u,
      onStepKeyDown: b,
      ...h
    } = e, [s, d] = l.useState(null), v = C(t, (w) => d(w)), P = l.useRef(void 0), g = de(r), S = g === "ltr", f = S && !c || !S && c;
    function D(w) {
      const p = P.current || s.getBoundingClientRect(), K = [0, p.width], N = F(K, f ? [o, n] : [n, o]);
      return P.current = p, N(w - p.left);
    }
    return /* @__PURE__ */ m(
      J,
      {
        scope: e.__scopeSlider,
        startEdge: f ? "left" : "right",
        endEdge: f ? "right" : "left",
        direction: f ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ m(
          Z,
          {
            dir: g,
            "data-orientation": "horizontal",
            ...h,
            ref: v,
            style: {
              ...h.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (w) => {
              const p = D(w.clientX);
              i?.(p);
            },
            onSlideMove: (w) => {
              const p = D(w.clientX);
              a?.(p);
            },
            onSlideEnd: () => {
              P.current = void 0, u?.();
            },
            onStepKeyDown: (w) => {
              const K = W[f ? "from-left" : "from-right"].includes(w.key);
              b?.({ event: w, direction: K ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), be = l.forwardRef(
  (e, t) => {
    const {
      min: o,
      max: n,
      inverted: r,
      onSlideStart: c,
      onSlideMove: i,
      onSlideEnd: a,
      onStepKeyDown: u,
      ...b
    } = e, h = l.useRef(null), s = C(t, h), d = l.useRef(void 0), v = !r;
    function P(g) {
      const S = d.current || h.current.getBoundingClientRect(), f = [0, S.height], w = F(f, v ? [n, o] : [o, n]);
      return d.current = S, w(g - S.top);
    }
    return /* @__PURE__ */ m(
      J,
      {
        scope: e.__scopeSlider,
        startEdge: v ? "bottom" : "top",
        endEdge: v ? "top" : "bottom",
        size: "height",
        direction: v ? 1 : -1,
        children: /* @__PURE__ */ m(
          Z,
          {
            "data-orientation": "vertical",
            ...b,
            ref: s,
            style: {
              ...b.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (g) => {
              const S = P(g.clientY);
              c?.(S);
            },
            onSlideMove: (g) => {
              const S = P(g.clientY);
              i?.(S);
            },
            onSlideEnd: () => {
              d.current = void 0, a?.();
            },
            onStepKeyDown: (g) => {
              const f = W[v ? "from-bottom" : "from-top"].includes(g.key);
              u?.({ event: g, direction: f ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Z = l.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: o,
      onSlideStart: n,
      onSlideMove: r,
      onSlideEnd: c,
      onHomeKeyDown: i,
      onEndKeyDown: a,
      onStepKeyDown: u,
      ...b
    } = e, h = B(M, o);
    return /* @__PURE__ */ m(
      T.span,
      {
        ...b,
        ref: t,
        onKeyDown: E(e.onKeyDown, (s) => {
          s.key === "Home" ? (i(s), s.preventDefault()) : s.key === "End" ? (a(s), s.preventDefault()) : X.concat(G).includes(s.key) && (u(s), s.preventDefault());
        }),
        onPointerDown: E(e.onPointerDown, (s) => {
          const d = s.target;
          d.setPointerCapture(s.pointerId), s.preventDefault(), h.thumbs.has(d) ? d.focus() : n(s);
        }),
        onPointerMove: E(e.onPointerMove, (s) => {
          s.target.hasPointerCapture(s.pointerId) && r(s);
        }),
        onPointerUp: E(e.onPointerUp, (s) => {
          const d = s.target;
          d.hasPointerCapture(s.pointerId) && (d.releasePointerCapture(s.pointerId), c(s));
        })
      }
    );
  }
), ee = "SliderTrack", we = l.forwardRef(
  (e, t) => {
    const { __scopeSlider: o, ...n } = e, r = B(ee, o);
    return /* @__PURE__ */ m(
      T.span,
      {
        "data-disabled": r.disabled ? "" : void 0,
        "data-orientation": r.orientation,
        ...n,
        ref: t
      }
    );
  }
);
we.displayName = ee;
var O = "SliderRange", ye = l.forwardRef(
  (e, t) => {
    const { __scopeSlider: o, ...n } = e, r = B(O, o), c = Q(O, o), i = l.useRef(null), a = C(t, i), u = r.values.length, b = r.values.map(
      (d) => oe(d, r.min, r.max)
    ), h = u > 1 ? Math.min(...b) : 0, s = 100 - Math.max(...b);
    return /* @__PURE__ */ m(
      T.span,
      {
        "data-orientation": r.orientation,
        "data-disabled": r.disabled ? "" : void 0,
        ...n,
        ref: a,
        style: {
          ...e.style,
          [c.startEdge]: h + "%",
          [c.endEdge]: s + "%"
        }
      }
    );
  }
);
ye.displayName = O;
var L = "SliderThumb", te = l.forwardRef(
  (e, t) => {
    const o = Se(e.__scopeSlider), [n, r] = l.useState(null), c = C(t, (a) => r(a)), i = l.useMemo(
      () => n ? o().findIndex((a) => a.ref.current === n) : -1,
      [o, n]
    );
    return /* @__PURE__ */ m(Pe, { ...e, ref: c, index: i });
  }
), Pe = l.forwardRef(
  (e, t) => {
    const { __scopeSlider: o, index: n, name: r, ...c } = e, i = B(L, o), a = Q(L, o), [u, b] = l.useState(null), h = C(t, (D) => b(D)), s = u ? i.form || !!u.closest("form") : !0, d = fe(u), v = i.values[n], P = v === void 0 ? 0 : oe(v, i.min, i.max), g = De(n, i.values.length), S = d?.[a.size], f = S ? Ee(S, P, a.direction) : 0;
    return l.useEffect(() => {
      if (u)
        return i.thumbs.add(u), () => {
          i.thumbs.delete(u);
        };
    }, [u, i.thumbs]), /* @__PURE__ */ se(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [a.startEdge]: `calc(${P}% + ${f}px)`
        },
        children: [
          /* @__PURE__ */ m(H.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(
            T.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || g,
              "aria-valuemin": i.min,
              "aria-valuenow": v,
              "aria-valuemax": i.max,
              "aria-orientation": i.orientation,
              "data-orientation": i.orientation,
              "data-disabled": i.disabled ? "" : void 0,
              tabIndex: i.disabled ? void 0 : 0,
              ...c,
              ref: h,
              style: v === void 0 ? { display: "none" } : e.style,
              onFocus: E(e.onFocus, () => {
                i.valueIndexToChangeRef.current = n;
              })
            }
          ) }),
          s && /* @__PURE__ */ m(
            ne,
            {
              name: r ?? (i.name ? i.name + (i.values.length > 1 ? "[]" : "") : void 0),
              form: i.form,
              value: v
            },
            n
          )
        ]
      }
    );
  }
);
te.displayName = L;
var xe = "RadioBubbleInput", ne = l.forwardRef(
  ({ __scopeSlider: e, value: t, ...o }, n) => {
    const r = l.useRef(null), c = C(r, n), i = ue(t);
    return l.useEffect(() => {
      const a = r.current;
      if (!a) return;
      const u = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(u, "value").set;
      if (i !== t && h) {
        const s = new Event("input", { bubbles: !0 });
        h.call(a, t), a.dispatchEvent(s);
      }
    }, [i, t]), /* @__PURE__ */ m(
      T.input,
      {
        style: { display: "none" },
        ...o,
        ref: c,
        defaultValue: t
      }
    );
  }
);
ne.displayName = xe;
function Re(e = [], t, o) {
  const n = [...e];
  return n[o] = t, n.sort((r, c) => r - c);
}
function oe(e, t, o) {
  const c = 100 / (o - t) * (e - t);
  return j(c, [0, 100]);
}
function De(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function _e(e, t) {
  if (e.length === 1) return 0;
  const o = e.map((r) => Math.abs(r - t)), n = Math.min(...o);
  return o.indexOf(n);
}
function Ee(e, t, o) {
  const n = e / 2, c = F([0, 50], [0, n]);
  return (n - c(t) * o) * o;
}
function Ce(e) {
  return e.slice(0, -1).map((t, o) => e[o + 1] - t);
}
function Me(e, t) {
  if (t > 0) {
    const o = Ce(e);
    return Math.min(...o) >= t;
  }
  return !0;
}
function F(e, t) {
  return (o) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (o - e[0]);
  };
}
function Ke(e) {
  return (String(e).split(".")[1] || "").length;
}
function Ie(e, t) {
  const o = Math.pow(10, t);
  return Math.round(e * o) / o;
}
const $ = {
  "slider-thumb": "_slider-thumb_s4aax_29",
  "slider-thumb-current-value": "_slider-thumb-current-value_s4aax_47"
};
function Le({ value: e, ariaLabel: t }) {
  const { value: o, setTrue: n, setFalse: r } = me();
  return /* @__PURE__ */ m(te, { className: $["slider-thumb"], onFocus: n, onBlur: r, "aria-label": t, children: o && /* @__PURE__ */ m("span", { className: $["slider-thumb-current-value"], children: e }) });
}
export {
  ge as S,
  Le as T,
  we as a,
  ye as b
};
